import * as api from '../api/account';

export const getAccount = (id) => async (dispatch) => {
  try {
    dispatch({ type: 'START_LOADING'});
      const { data } = await api.fetchAccount(id);

      dispatch({ type: 'FETCH_ACCOUNT', payload: data });
      dispatch({ type: 'STOP_LOADING'});
  } catch (error) {
      console.log(error.message);
  }
}

export const getAccounts = () => async (dispatch) => {
  try {
    dispatch({ type: 'START_LOADING'});
      const { data } = await api.fetchAccounts();

      dispatch({ type: 'FETCH_ACCOUNTS', payload: data });
      dispatch({ type: 'STOP_LOADING'});
  } catch (error) {
      console.log(error.message);
  }
}

export const sendMSG = (msgDets, userID) => async (dispatch) => {
  try {
    dispatch({ type: 'START_SENDING'});
    const {data} = await api.msg(msgDets, userID);
    
    dispatch({ type: 'MSG', payload: data})
    
    dispatch({ type: 'STOP_SENDING'});
    return data.liveChats;
  } catch (error) {
    console.log(error);
  }
}

export const updateMsgCounterSupport = (current, userID) => async (dispatch) => {
  try {
    const {data} = await api.updateMsgCounterSupport(current, userID);
    
    dispatch({ type: 'UPDATE', payload: data})
  } catch (error) {
    console.log(error);
  }
}